<template>
    <WheelAssembly ref="wheelRef" :segments="segments" @spin-complete="onSpinComplete" @spin-error="onSpinError">
        <template #overlay v-if="cantSpin">
            <WheelTimer :endTime="timerEndTime" class="spin-the-wheel__timer--large" />
        </template>
    </WheelAssembly>
</template>



<script setup>

import { ref, computed } from 'vue';
import WheelTimer from './WheelTimer.vue';
import WheelAssembly from './WheelParts/WheelAssembly.vue';
import { SpinTheWheelStore } from '@/store/SpinTheWheelStore';
import { useUserStore } from '@/store/UserStore';
import { UserActivityStore } from '@/store/UserActivityStore';

// Initialize the store
const result = ref('');
const wheelRef = ref(null);
const spinTheWheelStore = SpinTheWheelStore();
const userStore = useUserStore();
const userActivityStore = UserActivityStore();

const cantSpin = computed(() => {
    return spinTheWheelStore.wheelStatus.cant_spin;
});

const timerEndTime = computed(() => {
    return spinTheWheelStore.wheelStatus.end_time || 0;
});

// Compute segments with random colors
const segments = computed(() =>
    spinTheWheelStore.sections.map(section => ({
        label: section.value,
        text: section.text
    }))
);

// Spin function
const spin = async () => {
    if (wheelRef.value?.isSpinning) return;
    result.value = '';

    try {
        // Fetch the spin result from the API
        await spinTheWheelStore.getResult();
        const resultValue = spinTheWheelStore.result.value;

        // Trigger the wheel spin
        wheelRef.value?.spin(resultValue);
    } catch (error) {
        console.error('Spin failed:', error);
        result.value = 'Error!';
    }
};

const onSpinComplete = async (resultValue) => {
    result.value = resultValue;
    
    // Update wheel data
    await spinTheWheelStore.getWheelInitialData();
    await spinTheWheelStore.getActiveWheelRewards();
    
    // Update user's coins balance and earnings list
    if (spinTheWheelStore.result.type === 'fixed_coins') {
        await userActivityStore.getEarnData();
    }
};

const onSpinError = () => {
    result.value = 'Error!';
};

// Expose necessary methods and refs to parent
defineExpose({
    spin,
    isSpinning: computed(() => wheelRef.value?.isSpinning)
});

</script>